import React, { useCallback } from 'react'
import styles from './CrmModule.module.css'
import { useTranslation } from "react-i18next";
import { RiContactsLine } from "react-icons/ri";
import { BiCustomize } from "react-icons/bi";
import { LuActivity } from "react-icons/lu";
import { BsBoxArrowInDownLeft } from "react-icons/bs";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { RxDragHandleHorizontal } from "react-icons/rx";





const CrmModule = (props) => {
    const [t] = useTranslation('crm')
    const { id, title, style, disabled, onClick,selectedModule,moduleSelectionMode } = props

    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });


    const dStyle = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1, // ✅ Make it slightly transparent while dragging
        scale: isDragging ? 1.05 : 1,  // ✅ Slightly enlarge when dragging
    };

    let IconElement = <BiCustomize />

    switch (title) {
        case 'contacts':
            IconElement = RiContactsLine
            break;
        case 'activities':
            IconElement = LuActivity
            break;
        case 'inquiries':
            IconElement = BsBoxArrowInDownLeft
            break;
        default:
            IconElement = BiCustomize
    }

    return <article
        ref={setNodeRef}
        style={{ ...dStyle, ...style }}
        {...attributes}
        {...listeners}
        className={`${styles['card-container']} ${moduleSelectionMode==='select' && selectedModule?._id === id && styles['card-container--selected']}`} 
        onClick={()=>onClick()}
    >

        <section className={styles['module-info']}>
            <p className={styles['module-title']}>{t(title)}</p>
        </section>
        <section className={`${styles['side-icon']} ${moduleSelectionMode==='select' && selectedModule?._id === id && styles['side-icon--selected']}`}>
            <div className={`${styles['icon-container']} ${moduleSelectionMode==='select' && selectedModule?._id === id && styles['icon-container--selected']}`}>
                <IconElement className={styles['icon']} />
            </div>
        </section>
        {
            !disabled &&
            <section className={`${styles['side-icon']} `}>
                <div className={styles['drag-and-drop-container']}>
                    <RxDragHandleHorizontal className={styles['icon']} />
                </div>
            </section>
        }
    </article>
}

export default CrmModule